import request from './request'
import { CONFIG_COIN_URL } from './config'

/**
 * 获取各创作类型消耗积分配置
 * @returns {Promise<{ shortNovel?: number, coreIdea?: number, outline?: number, cover?: number } | null>}
 */
export async function getCoinConfig () {
  try {
    const data = await request.get(CONFIG_COIN_URL)
    if (!data || typeof data !== 'object') return null
    return data
  } catch (e) {
    return null
  }
}
